/* eslint-disable jira/naming/disallow-filenames */

import React from 'react';
import type { OrganizationAppWithLayout as ServicedeskOrganizationV2Type } from '@jira/spa-apps__servicedesk-organization-v2/src/OrganizationAppWithLayout.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyServicedeskOrganizationV2: LazyComponent<() => React.JSX.Element> = lazyForPaint<
	typeof ServicedeskOrganizationV2Type
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-servicedesk-organization-v2", jiraSpaEntry: "async-servicedesk-organization-v2" */ '@jira/spa-apps__servicedesk-organization-v2/src/ServicedeskOrganizationV2.tsx'
		),
	),
);

export const ServiceDeskOrganizationV2 = (): React.JSX.Element => (
	<LazyPage
		Page={LazyServicedeskOrganizationV2}
		pageId="spa-apps/servicedesk/organization-v2"
		shouldShowSpinner
	/>
);
